import mapFunction from './mapResources';

export default mapFunction('employees', {
    isFetching: false,
    items: [] 
});